var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('talent-info',{attrs:{"row":_vm.row}},[(!['0', '2'].includes(_vm.row.is_effective) && !_vm.$isSp(_vm.row.platform_id))?_c('popover',{attrs:{"row":_vm.row},on:{"refresh":_vm.refresh}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }